
import AppLayout from "@/components/layout/AppLayout";
import { useUserRoles } from "@/hooks/useUserRoles";
import { useConditionalModules } from "@/hooks/useConditionalModules";
import { Navigate } from "react-router-dom";
import { EquipmentManagement } from "./components/EquipmentManagement";
import { ModuleDisabledMessage } from "@/components/ModuleDisabledMessage";
import { useLanguage } from "@/contexts/LanguageContext";

const EquipmentPage = () => {
  const { isAdmin, isLoading } = useUserRoles();
  const { isModuleEnabled, isLoading: moduleLoading } = useConditionalModules();
  const { t } = useLanguage();
  
  if (isLoading || moduleLoading) {
    return (
      <AppLayout>
        <div className="container py-4 md:py-8">
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </AppLayout>
    );
  }
  
  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  if (!isModuleEnabled("equipment_management")) {
    return (
      <AppLayout>
        <div className="container mx-auto py-6">
          <ModuleDisabledMessage
            moduleName="equipment_management"
            title={t("equipment")}
            description={t("moduleNotAvailable")}
          />
        </div>
      </AppLayout>
    );
  }
  
  return (
    <AppLayout>
      <div className="container py-4 md:py-8">
        <h1 className="text-3xl font-bold tracking-tight mb-6">Protective Equipment Management</h1>
        <EquipmentManagement />
      </div>
    </AppLayout>
  );
};

export default EquipmentPage;
